import qs from 'query-string';

const fromQueryString = (queryString, queryOptions) => {
  return {
    ...queryOptions,
    ...qs.parse(queryString),
  };
};

export default fromQueryString;
